export default "__VITE_ASSET__8d9af1f9__"